export const initialAddOns = {
  addOnOpts: [{}],
  selectedAddOns: [{}],
  bundleOpts: [{}],
};

export default initialAddOns;
